const featuresData = [
  {
    id: 'f1',
    icon: 'ri-tv-2-line',
    title: '海量综艺资源',
    description: '收录全网热门综艺节目，覆盖爆笑喜剧、音乐选秀、真人秀、访谈脱口秀等全品类，每日更新不断档。',
  },
  {
    id: 'f2',
    icon: 'ri-4k-line',
    title: '高清流畅播放',
    description: '多线路智能切换，高清画质即点即播，不缓冲不卡顿，无论宽带还是移动网络都能畅享极致观影体验。',
  },
  {
    id: 'f3',
    icon: 'ri-refresh-line',
    title: '每日同步更新',
    description: '与各大平台同步更新，最新综艺第一时间上线，不再错过任何精彩瞬间，追更党必备观影入口。',
  },
  {
    id: 'f4',
    icon: 'ri-vip-diamond-line',
    title: '完全免费观看',
    description: '所有综艺节目无需注册登录、无需付费会员，打开就能看。无广告打扰，纯粹观影体验。',
  },
];

const commentsData = [
  {
    id: 'c1',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20young%20Chinese%20woman%20with%20warm%20smile%2C%20clean%20studio%20background%2C%20soft%20natural%20lighting%2C%20professional%20look&width=80&height=80&seq=avatar-c1&orientation=squarish',
    name: '综艺迷小陈',
    role: '忠实用户 · 使用 2 年',
    content: '6789影院真的太良心了！追了三年的综艺全在这里，画质清晰流畅，最关键是完全免费，已经推荐给身边所有朋友了。',
    rating: 5,
  },
  {
    id: 'c2',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20young%20Chinese%20man%20with%20friendly%20expression%2C%20casual%20style%2C%20clean%20bright%20studio%20background&width=80&height=80&seq=avatar-c2&orientation=squarish',
    name: '追更达人阿杰',
    role: '综艺博主 · 使用 1 年',
    content: '更新速度没得说，当天播出的节目晚上就能看到。播放体验也一流，从来没遇到过缓冲问题，打工人的快乐源泉。',
    rating: 5,
  },
  {
    id: 'c3',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20middle-aged%20Chinese%20woman%20with%20kind%20smile%2C%20warm%20studio%20lighting%2C%20elegant%20casual%20style&width=80&height=80&seq=avatar-c3&orientation=squarish',
    name: '家庭观众王姐',
    role: '全职妈妈 · 使用半年',
    content: '周末全家一起看综艺是固定节目，6789影院分类特别全，喜剧、音乐、亲子类都有，一家人各取所需，氛围感拉满。',
    rating: 5,
  },
  {
    id: 'c4',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20young%20Chinese%20student%20with%20bright%20eyes%2C%20modern%20casual%20style%2C%20clean%20minimal%20studio%20background&width=80&height=80&seq=avatar-c4&orientation=squarish',
    name: '学生党小琳',
    role: '大学生 · 使用 3 个月',
    content: '宿舍网速一般，但6789影院加载速度真的快！课间休息看一段综艺放松一下，不占流量画质还特别好，太适合学生了。',
    rating: 4,
  },
];

const rankingData = [
  { id: 'r1', rank: 1, title: '奔跑吧·特别季', category: '户外真人秀', heat: '9.8', trend: 'up', tag: '热播中' },
  { id: 'r2', rank: 2, title: '歌手·巅峰之战', category: '音乐竞演', heat: '9.7', trend: 'up', tag: '新上线' },
  { id: 'r3', rank: 3, title: '脱口秀大会·新声季', category: '语言喜剧', heat: '9.5', trend: 'up', tag: '人气飙升' },
  { id: 'r4', rank: 4, title: '向往的生活·海岛篇', category: '慢综艺', heat: '9.3', trend: 'stable', tag: '' },
  { id: 'r5', rank: 5, title: '这就是街舞·国际赛', category: '舞蹈竞技', heat: '9.2', trend: 'up', tag: '口碑爆棚' },
  { id: 'r6', rank: 6, title: '密室大逃脱·城市版', category: '推理探秘', heat: '9.0', trend: 'stable', tag: '' },
];

const cardsData = [
  {
    id: 'cd1',
    image: 'https://readdy.ai/api/search-image?query=Vibrant%20Chinese%20variety%20show%20studio%20scene%20with%20colorful%20stage%20lighting%2C%20hosts%20and%20guests%20interacting%20cheerfully%2C%20entertainment%20show%20atmosphere%2C%20warm%20tones%2C%20professional%20TV%20production%20quality&width=600&height=400&seq=card-cd1&orientation=landscape',
    tag: '爆笑喜剧',
    title: '2026 年度十大爆笑综艺盘点',
    description: '从经典喜剧到新生代笑匠，精选本年度最令人捧腹的综艺佳作，承包你一整年的快乐源泉。',
    date: '2026-07-28',
  },
  {
    id: 'cd2',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20music%20stage%20with%20spotlights%20and%20dramatic%20atmosphere%2C%20Chinese%20talent%20show%20set%20design%2C%20warm%20golden%20and%20deep%20red%20lighting%2C%20professional%20concert%20production&width=600&height=400&seq=card-cd2&orientation=landscape',
    tag: '音乐选秀',
    title: '音乐综艺新风向：原创力量崛起',
    description: '原创音乐人竞演节目扎堆上线，从民谣到电子全面开花，见证华语乐坛新生力量的破茧时刻。',
    date: '2026-07-25',
  },
  {
    id: 'cd3',
    image: 'https://readdy.ai/api/search-image?query=Exciting%20outdoor%20adventure%20reality%20show%20scene%20with%20Chinese%20celebrities%20doing%20challenges%2C%20beautiful%20natural%20landscape%20background%2C%20action%20oriented%20vibe%2C%20bright%20sunlight&width=600&height=400&seq=card-cd3&orientation=landscape',
    tag: '户外真人秀',
    title: '真人秀暑期大战：谁将笑到最后',
    description: '多档户外真人秀暑期正面交锋，明星阵容、制作规模全面升级，这场收视争夺战精彩程度不输节目本身。',
    date: '2026-07-22',
  },
  {
    id: 'cd4',
    image: 'https://readdy.ai/api/search-image?query=Cozy%20indoor%20living%20room%20setting%20for%20talk%20show%20with%20warm%20ambient%20lighting%2C%20comfortable%20sofa%20and%20bookshelves%2C%20intimate%20conversation%20atmosphere%2C%20Chinese%20interview%20program%20style&width=600&height=400&seq=card-cd4&orientation=landscape',
    tag: '深度访谈',
    title: '慢综艺回潮：在快时代寻找慢生活',
    description: '生活类慢综艺再度走红，逃离都市喧嚣、回归田园本真，治愈系内容成为观众精神角落的新选择。',
    date: '2026-07-18',
  },
  {
    id: 'cd5',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20comedy%20stage%20performance%20with%20stand-up%20comedian%20under%20spotlight%2C%20audience%20laughing%2C%20warm%20stage%20lighting%2C%20professional%20theater%20setting%2C%20energetic%20atmosphere&width=600&height=400&seq=card-cd5&orientation=landscape',
    tag: '语言喜剧',
    title: '脱口秀新势力：五组值得关注的新人',
    description: '新一代脱口秀演员正在改写喜剧版图，犀利观察+独特视角，这五组新人用段子重新定义有趣的表达。',
    date: '2026-07-15',
  },
];

const carouselData = [
  {
    id: 'cr1',
    image: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20variety%20show%20grand%20stage%20with%20dramatic%20red%20and%20gold%20lighting%2C%20hosts%20on%20stage%2C%20large%20LED%20screens%2C%20spectacular%20TV%20production%20quality%2C%20elegant%20and%20energetic&width=800&height=450&seq=carousel-cr1&orientation=landscape',
    tag: '重磅推荐',
    title: '暑期综艺嘉年华',
    subtitle: '10+ 档王牌节目集中上线 · 全品类覆盖',
    description: '这个夏天，6789影院集结年度最强综艺阵容，从户外竞技到音乐盛宴，给你的暑假装满精彩。',
  },
  {
    id: 'cr2',
    image: 'https://readdy.ai/api/search-image?query=Warm%20family%20evening%20scene%20with%20Chinese%20family%20watching%20TV%20together%20on%20comfortable%20sofa%2C%20cozy%20living%20room%20with%20soft%20lighting%2C%20happy%20expressions%2C%20entertainment%20atmosphere&width=800&height=450&seq=carousel-cr2&orientation=landscape',
    tag: '亲子时光',
    title: '合家欢综艺精选',
    subtitle: '亲子互动 · 寓教于乐 · 全家共享',
    description: '精选适合全家一起观看的优质综艺，亲子手工、知识竞赛、家庭挑战，让客厅成为最温馨的互动空间。',
  },
  {
    id: 'cr3',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20music%20competition%20stage%20with%20singer%20performing%20under%20dramatic%20spotlights%2C%20passionate%20expression%2C%20grand%20concert%20hall%20atmosphere%2C%20professional%20sound%20and%20light%20production&width=800&height=450&seq=carousel-cr3&orientation=landscape',
    tag: '音综专场',
    title: '华语音乐综艺大赏',
    subtitle: '竞演 · 创作 · 乐队 · 跨界',
    description: '从经典翻唱到原创舞台，音乐综艺正在重塑华语乐坛生态。一站式收录最全音综，每一首都值得用心聆听。',
  },
  {
    id: 'cr4',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20wide%20shot%20of%20modern%20Chinese%20TV%20studio%20with%20multiple%20screens%20displaying%20various%20shows%2C%20broadcasting%20control%20room%20aesthetic%2C%20professional%20media%20production%2C%20warm%20and%20futuristic%20lighting&width=800&height=450&seq=carousel-cr4&orientation=landscape',
    tag: '新番速递',
    title: '即将上线：秋季新综前瞻',
    subtitle: '抢先预览 · 独家整理 · 追更日历',
    description: '秋季档综艺蓄势待发，6789影院提前为你整理最全上新清单，不错过任何一档值得期待的新节目。',
  },
];

const contactData = {
  title: '投稿与合作',
  description: '如果你有精彩的综艺推荐、节目资源分享，或者希望与我们展开内容合作，欢迎通过以下方式联系我们。6789影院期待与更多综艺爱好者一起打造最全、最快、最好的综艺观影平台。',
  email: 'contact@6789cinema.com',
  qq: '1234567890',
  wechat: 'cinema6789',
};

const updatesData = [
  { id: 'u1', date: '2026-08-01', title: '「奔跑吧·特别季」第三期已更新，高清完整版上线', type: 'update' },
  { id: 'u2', date: '2026-07-31', title: '「歌手·巅峰之战」半决赛舞台纯享版独家收录', type: 'update' },
  { id: 'u3', date: '2026-07-30', title: '「脱口秀大会·新声季」突围赛完整合集已整理', type: 'update' },
  { id: 'u4', date: '2026-07-29', title: '6789影院服务器全面升级，播放加载速度提升 40%', type: 'notice' },
  { id: 'u5', date: '2026-07-27', title: '新增「综艺专题」版面，按主题快速定位想看的内容', type: 'notice' },
  { id: 'u6', date: '2026-07-25', title: '「密室大逃脱·城市版」新密室地图解锁，剧情高能', type: 'update' },
  { id: 'u7', date: '2026-07-23', title: '「这就是街舞·国际赛」海外选手专场引发全网热议', type: 'update' },
];

const aboutData = {
  title: '关于 6789影院',
  paragraphs: [
    '6789影院成立于2024年，是一个专注于综艺节目资源整合与在线观看的综合性平台。我们致力于为全国综艺爱好者提供免费、高清、流畅的综艺观看体验，让每一位用户都能轻松找到自己想看的内容。',
    '平台目前已收录超过500档热门综艺节目，覆盖户外真人秀、音乐竞演、语言喜剧、慢综艺、推理探秘、舞蹈竞技等全品类。我们的内容团队每日追踪各大平台更新动态，确保最新节目第一时间上线。',
    '6789影院的核心理念是「让好综艺触手可及」。我们相信优质的综艺内容不应该被付费墙阻隔，每一个观众都值得享受轻松愉悦的观影时光。未来，我们将持续扩充内容库、优化播放体验，打造最受信赖的中文综艺观影平台。',
  ],
  stats: [
    { value: '500+', label: '收录节目' },
    { value: '30万+', label: '日均访客' },
    { value: '99.9%', label: '播放成功率' },
    { value: '7×24', label: '持续更新' },
  ],
};

const indexData = [
  { id: 'i1', title: '户外真人秀', count: 86, icon: 'ri-compass-3-line', description: '奔跑吧、极限挑战、花儿与少年等户外竞技与旅行真人秀全收录' },
  { id: 'i2', title: '音乐竞演', count: 63, icon: 'ri-music-2-line', description: '歌手、中国好声音、天赐的声音等音乐类综艺现场纯享' },
  { id: 'i3', title: '语言喜剧', count: 47, icon: 'ri-emotion-laugh-line', description: '脱口秀大会、吐槽大会、一年一度喜剧大赛等爆笑语言节目大全' },
  { id: 'i4', title: '慢综艺', count: 38, icon: 'ri-home-heart-line', description: '向往的生活、中餐厅、亲爱的客栈等治愈系生活慢综艺精选' },
  { id: 'i5', title: '推理探秘', count: 29, icon: 'ri-search-eye-line', description: '密室大逃脱、明星大侦探、开始推理吧等烧脑推理综艺' },
  { id: 'i6', title: '舞蹈竞技', count: 24, icon: 'ri-run-line', description: '这就是街舞、舞蹈风暴、起舞吧等热血舞蹈竞演节目' },
  { id: 'i7', title: '亲子少儿', count: 31, icon: 'ri-parent-line', description: '爸爸去哪儿、萌探探探案、疯狂的麦咭等亲子互动与少儿益智综艺' },
];

const faqData = [
  {
    id: 'q1',
    question: '6789影院需要注册会员才能观看吗？',
    answer: '完全不需要。6789影院所有综艺节目均为免费观看，无需注册、无需登录、无需付费。打开网站即可直接选择喜欢的节目开始播放，我们承诺永久免费。',
  },
  {
    id: 'q2',
    question: '综艺节目的更新速度怎么样？',
    answer: '我们的内容团队与各大播出平台保持同步更新，大部分热门综艺在电视首播当晚即可在6789影院上线。每天早晨和晚间各进行一次集中更新，确保你不会错过任何精彩内容。',
  },
  {
    id: 'q3',
    question: '播放时出现卡顿怎么办？',
    answer: '6789影院为每档节目配备了多条备用播放线路。如果遇到卡顿，可以尝试在播放页面切换其他线路。同时我们的服务器已完成全面升级，正常情况下高清播放流畅无缓冲。',
  },
  {
    id: 'q4',
    question: '可以在手机或平板上观看吗？',
    answer: '当然可以。6789影院全面适配手机、平板和电脑等各类设备，无论你使用 iOS、Android 还是 Windows 系统，打开浏览器即可获得最佳观影体验。推荐使用 Chrome 或 Safari 浏览器。',
  },
];

const topicsData = [
  { id: 't1', name: '奔跑吧特别季', heat: '98°', color: 'hot' },
  { id: 't2', name: '歌手巅峰之战', heat: '96°', color: 'hot' },
  { id: 't3', name: '脱口秀大会', heat: '94°', color: 'hot' },
  { id: 't4', name: '这就是街舞', heat: '91°', color: 'warm' },
  { id: 't5', name: '密室大逃脱', heat: '88°', color: 'warm' },
  { id: 't6', name: '向往的生活', heat: '85°', color: 'warm' },
  { id: 't7', name: '暑期综艺档', heat: '82°', color: 'warm' },
  { id: 't8', name: '原创音乐综艺', heat: '78°', color: 'normal' },
  { id: 't9', name: '慢综艺回潮', heat: '75°', color: 'normal' },
  { id: 't10', name: '合家欢综艺', heat: '72°', color: 'normal' },
];

const mediaData = [
  {
    id: 'm1',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20thumbnail%20style%20image%20of%20Chinese%20outdoor%20reality%20show%20with%20celebrities%20running%20and%20laughing%2C%20bright%20sunlight%2C%20action%20pose%2C%20video%20player%20overlay%20aesthetic%2C%20warm%20vibrant%20colors&width=640&height=360&seq=media-m1&orientation=landscape',
    title: '奔跑吧·特别季 EP03',
    duration: '1:28:45',
    views: '128.6万',
    tag: '热播',
  },
  {
    id: 'm2',
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20music%20stage%20thumbnail%20with%20Chinese%20singer%20under%20spotlight%2C%20passionate%20performance%2C%20concert%20lighting%20effects%2C%20video%20thumbnail%20style%2C%20deep%20red%20and%20gold%20color%20palette&width=640&height=360&seq=media-m2&orientation=landscape',
    title: '歌手·巅峰之战 半决赛',
    duration: '2:15:30',
    views: '96.3万',
    tag: '热播',
  },
  {
    id: 'm3',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20stand-up%20comedy%20stage%20thumbnail%2C%20comedian%20with%20microphone%20under%20warm%20spotlight%2C%20audience%20silhouettes%2C%20video%20player%20style%20overlay%2C%20energetic%20entertaining%20atmosphere&width=640&height=360&seq=media-m3&orientation=landscape',
    title: '脱口秀大会·新声季 EP05',
    duration: '1:05:20',
    views: '85.7万',
    tag: '新番',
  },
  {
    id: 'm4',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20dance%20competition%20thumbnail%20with%20dynamic%20dance%20pose%2C%20dramatic%20stage%20lighting%2C%20street%20dance%20aesthetic%2C%20video%20player%20overlay%2C%20high%20energy%20urban%20vibe&width=640&height=360&seq=media-m4&orientation=landscape',
    title: '这就是街舞·国际赛 EP08',
    duration: '1:42:15',
    views: '79.1万',
    tag: '热播',
  },
  {
    id: 'm5',
    image: 'https://readdy.ai/api/search-image?query=Mystery%20escape%20room%20TV%20show%20thumbnail%20with%20Chinese%20celebrities%20solving%20puzzles%2C%20dim%20dramatic%20lighting%2C%20suspenseful%20atmosphere%2C%20video%20player%20style%20overlay%2C%20cinematic%20thriller%20mood&width=640&height=360&seq=media-m5&orientation=landscape',
    title: '密室大逃脱·城市版 EP06',
    duration: '1:18:50',
    views: '72.4万',
    tag: '推荐',
  },
];

const appData = {
  title: '随时随地 · 综艺随身看',
  description: '6789影院全面适配移动端浏览器，无需下载 App，打开手机浏览器即可享受高清流畅的综艺观影体验。支持 iOS Safari 与 Android Chrome，还可在桌面端添加到浏览器收藏夹，一键直达。',
  features: ['免下载即开即看', '移动端播放优化', '省流量高清模式', '收藏夹一键直达'],
  image: 'https://readdy.ai/api/search-image?query=Modern%20smartphone%20displaying%20Chinese%20variety%20show%20streaming%20interface%20with%20video%20player%20and%20show%20thumbnails%2C%20clean%20UI%20design%2C%20warm%20entertainment%20app%20aesthetic%2C%20held%20in%20hand%20with%20minimal%20background&width=400&height=700&seq=app-hero&orientation=portrait',
};

export {
  featuresData,
  commentsData,
  rankingData,
  cardsData,
  carouselData,
  contactData,
  updatesData,
  aboutData,
  indexData,
  faqData,
  topicsData,
  mediaData,
  appData,
};